import React, { useState, useRef, useEffect, forwardRef, Fragment } from "react";
import { Grid, Box, Tabs, Tab, AppBar, Typography, Menu, MenuItem, IconButton,
         TextField, InputAdornment, CircularProgress, Tooltip, TableRow,
         TableCell, ListItemIcon, ListItemText, Checkbox, FormControl, Select
 } from "@material-ui/core";
import { Button, Link } from '../../components/Wrappers'
import MUIDataTable from "mui-datatables";
import { useHistory } from "react-router-dom";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import debounce from 'lodash.debounce';
import PropTypes from 'prop-types';
// components
import PageTitle from "../../components/PageTitle";
import Widget from "../../components/Widget";
import { withStyles } from '@material-ui/core/styles';
import AccountsTable from '../../components/Account/AccountsTable';
import ttAPI from '../../api/ttAPI';
// Icons
import {
    CalendarToday as CalendarTodayIcon,
    Check as CheckIcon,
    Delete as DeleteIcon,
    Receipt as ReceiptIcon,
} from '@material-ui/icons'


// Icons
import {
    Add as AddIcon,
    Chat as ChatIcon,
    MoreVert as MoreVertIcon,
    History as  HistoryIcon
} from '@material-ui/icons'

import enNZ from 'date-fns/locale/en-NZ'
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DateFnsUtils from '@date-io/date-fns';

import useStyles from './styles';
import config from '../../config';
import classnames from "classnames";

import RefundConfirmation from '../../components/RefundConfirmation/RefundConfirmation';
import { sendNotification, useUserState } from "../../context/UserContext";

import "./Refunds.css";

registerLocale('en-NZ', enNZ);

const Refunds = forwardRef((props, ref) => {
  // global
  const classes = useStyles();
  const history = useHistory();
  var { refund_types, refund_categories } = useUserState();

  // local
  var [data, setData] = useState([]);
  var [key, setKey] = useState(undefined);
  var [isLoading, setIsLoading] = useState(false);

  const [selectedRowIndex, setSelectedRowIndex] = useState(-1);

  const fromRef = useRef(null);
  const toRef = useRef(null);
  const [selectedFrom, setSelectedFrom] = React.useState();
  const [selectedTo, setSelectedTo] = React.useState();
  const fromCalendarRef = useRef(null);
  const toCalendarRef = useRef(null);
  const [fromOpen, setFromOpen] = React.useState(false);
  const [toOpen, setToOpen] = React.useState(false);
  const [fromFocused, setFromFocused] = React.useState(false);
  const [toFocused, setToFocused] = React.useState(false);
  const [isTimeRangeInvalid, setIsTimeRangeInvalid] = React.useState(false);

  const refundConfirmationRef = useRef(null);
  const [refundConfirmationIsOpen, setRefundConfirmationIsOpen] = useState(false);

  var [isEditingType, setIsEditingType] = useState(false);
  var [isEditingCategory, setIsEditingCategory] = useState(false);
  var [isEditingAmount, setIsEditingAmount] = useState(false);
  var [isEditingJobId, setIsEditingJobId] = useState(false);

  var [refundCategoriesOptions, setRefundCategoriesOptions] = useState([]);
  var [refundTypesOptions, setRefundTypesOptions] = useState([]);
  var [refundCategoriesOpen, setRefundCategoriesOpen] = useState(false);
  var [refundTypesOpen, setRefundTypesOpen] = useState(false);

  const StyledMenu = withStyles({
    paper: {
      border: '1px solid #d3d4d5',
    },
  })((props) => (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      {...props}
    />
  ));

  const StyledMenuItem = withStyles((theme) => ({
      root: {
        '&:focus': {
          backgroundColor: theme.palette.common.white
        },
      },
    }))(MenuItem);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [refundAction, setRefundAction] = React.useState('');

  const CustomHeaderCheckbox = ({ isChecked, handleHeaderCheckboxChange }) => (
      <Checkbox
        indeterminate={isChecked === 'indeterminate'}
        checked={isChecked === true}
        onChange={(e) => handleHeaderCheckboxChange(e.target.checked)}
      />
    );
const [selectedRows, setSelectedRows] = useState([]);
const handleRowCheckboxChange = (rowIndex) => {
    setSelectedRows((prevSelected) => {
      if (prevSelected.includes(rowIndex)) {
        return prevSelected.filter((index) => index !== rowIndex);
      } else {
        return [...prevSelected, rowIndex];
      }
    });
  };

  const columns = [

    { label: 'ID', name: 'id', options: {filter: false, display: true, searchable: false, download: true}},
    { label: 'ACCOUNT ID', name: 'account_id', options: {filter: false, display: false, download: true}},
    { label: 'Name', name: 'name', options: {filter: true, display: true, download: true, sort: true}},
    { label: 'Type', name: 'type', options: {filter: true, display: true, download: true, sort: true}},
    { label: 'JOB ID', name: 'job_id', options: {filter: true, display: true, sort: true}},
    { label: 'REASON', name: 'reason', options: {filter: false, sort: true}},
    { label: 'CATEGORY', name: 'category', options: {filter: true, sort: true}},
    { label: 'AMOUNT', name: 'amount', options: {filter: false, sort: true}},
    { label: 'TOKEN', name: 'token', options: {filter: false, display: false, searchable: false}},
    { label: 'SUBMITTED', name: 'submitted',
      options: {
        filter: false,
        display: true,
        sort: true,
        sortCompare: (order) => {
          return (obj1, obj2) => {
            let val1 = new Date(obj1.data);
            let val2 = new Date(obj2.data);
            return (val1 - val2) * (order === 'asc' ? 1 : -1);
          };
        },
    }},
    { label: 'APPROVED BY', name: 'approved_by', options: {filter: false, display: false, searchable: false}},
    { label: 'LATE SUBMIT', name: 'late_submit', options: {filter: false, display: false, searchable: false}},
    { label: 'ACTION',
        name: 'action',
        options: {
          filter: false,
          sort: false,
          empty: true/*,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (<div>
                <IconButton color="primary"
                      component="span"
                      onClick={handleClick}>
                    <MoreVertIcon />
                </IconButton>
            </div>)
          }*/
        }
      },
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsMenuOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRowIndex(-1);
    setIsMenuOpen(false);
  };

  useEffect(() => {
    if (fromCalendarRef !== undefined && fromCalendarRef !== null &&
      fromCalendarRef.current !== undefined && fromCalendarRef.current !== null) {
      fromCalendarRef.current.setOpen(fromFocused);
    }
  },[fromFocused]);

  useEffect(() => {
    if (toCalendarRef !== undefined && toCalendarRef !== null &&
      toCalendarRef.current !== undefined && toCalendarRef.current !== null) {
      toCalendarRef.current.setOpen(toFocused);
    }
  },[toFocused]);



  const getMuiTheme = () => createMuiTheme({
    palette: {
     primary: {
       main: '#FFCA06',
     },
   },
     overrides: {
       MuiTable: {
         root: {
           borderCollapse: 'inherit'
         }
       },
       MUIDataTableFilter: {
         root: {
           width: '500px',
         }
       },
       MuiTableCell: {
           root: {
               padding: '16px 16px',
               marginTop: '5px'
           },
           body: {
               color: 'inherit'
           }
       },
       MuiTableRow: {
         root: {
           '&$selected': {
             backgroundColor: 'rgba(25, 118, 210, 0.08) !important'
           }
         }
       },

     }
   });

   const onCellClick = (dataIndex, colIndex) => {
      setSelectedRowIndex(dataIndex);
   }

   useEffect(() => {
      let mounted = true;

      const fetchData = async () => {
        if (selectedFrom !== undefined && selectedFrom !== null &&
            selectedTo !== undefined && selectedTo !== null) {
          setIsLoading(true);
          let datetimeRange = processDateRange(selectedFrom, selectedTo);
          try {
            const response = await ttAPI.getRefunds(datetimeRange.from, datetimeRange.to);
            if (mounted) {
                if (response.error) {
                    setData([]);
                }
                else {
                    setData(response || []);
                }
                setIsLoading(false);
            }
          } catch (error) {
            if (mounted) {
              setData([]);
              setIsLoading(false);
            }
            console.error('Error fetching refunds:', error);
          }
        }
      };

      fetchData();

      return () => {
        mounted = false;
      };
    }, [selectedFrom, selectedTo]);


   async function refreshData() {
     let datetimeRange = processDateRange(selectedFrom, selectedTo)
     const response =await ttAPI.getRefunds(datetimeRange.from, datetimeRange.to);
     setData(response);
   }

   function formatDate(date) {
      let [d, m, y] = date.toLocaleDateString('en-NZ').split("/");
      let hour = ('0' + date.getHours()).slice(-2);
      let minute = ('0' + date.getMinutes()).slice(-2);
      let time = `${hour}:${minute}`;
      return { date: d, month: m, year: y, time: time };
    }

    function processDateRange(selectedFrom, selectedTo) {
        let from = selectedFrom;
        let to = selectedTo;

        if (from === undefined || from === null || to === undefined || to === null) {
            let timerange = getTwoWeekTimerange();
            from = timerange.start;
            to = timerange.end;
        }

        let formattedFrom = formatDate(from);
        let formattedTo = formatDate(to);

        return {
            from: `${formattedFrom.year}-${formattedFrom.month}-${formattedFrom.date} ${formattedFrom.time}`,
            to: `${formattedTo.year}-${formattedTo.month}-${formattedTo.date} ${formattedTo.time}`
        };
    }

   function getTwoWeekTimerange() {
       // Get today's date
       let today = new Date();

       // Calculate the start of the week (Monday) from two weeks ago
       let twoWeeksAgoMonday = new Date(today);
       twoWeeksAgoMonday.setDate(twoWeeksAgoMonday.getDate() - (today.getDay() + 6) % 7 - 14); // Subtract 14 days for two weeks ago
       twoWeeksAgoMonday.setHours(10, 30, 0, 0); // Set time to midnight

       // Calculate the end of the week (Sunday) from last week
       let thisMonday = new Date(today);
       thisMonday.setDate(thisMonday.getDate() - today.getDay() + 1); // Subtract days until this Monday
       thisMonday.setHours(10, 30, 0, 0); // Set time to 11am of the day

       return {
           start: twoWeeksAgoMonday,
           end: thisMonday
       };
   }

   const getRandomInt = (max) => {
     return Math.floor(Math.random() * Math.floor(max));
   }

   const onMouseDown = e => {
     e.stopPropagation();
   };

   // triggered if value changes, but not save anywhere as the value here can be in-progress (if use keyboard)
   function handleChangeFrom(d) {
     setSelectedFrom(d);

     let datetimeRange = processDateRange(d, selectedTo);
     var filterList = JSON.parse(localStorage.getItem('refunds_filter_list'));
     filterList[0] = datetimeRange.from;
     localStorage.setItem('refunds_filter_list', JSON.stringify(filterList));
   }

   function handleChangeTo(d) {
     setSelectedTo(d);

     let datetimeRange = processDateRange(selectedFrom, d);
     var filterList = JSON.parse(localStorage.getItem('refunds_filter_list'));
     filterList[1] = datetimeRange.to;
     localStorage.setItem('refunds_filter_list', JSON.stringify(filterList));
   }

   function onFocusFrom(event) {
     setFromFocused(true);
   }

   function onFocusTo(event) {
     setToFocused(true);
   }

   function blurFrom(event) {
     setFromFocused(false);
   }

   function blurTo(event) {
     setToFocused(false);
   }

   function handleSelectFrom(d) {
     setSelectedFrom(d);
   }

   function handleSelectTo(d) {
     setSelectedTo(d);
   }

   // triggered if use keyboard
   function handleFromKeyPress(event) {
     if (event.which === 9 || event.which === 13 || event.which === 27) {
       setFromFocused(false);
     }
   }

   function handleToKeyPress(event) {
     if (event.which === 9 || event.which === 13 || event.which === 27) {
       setToFocused(false);
     }
   }

   const approveRefund = async () => {
       const response = await ttAPI.approveRefund( data[selectedRowIndex].id);
       handleClose();
   }

   const deleteRefund = async () => {
       const response = await ttAPI.deleteRefund( data[selectedRowIndex].id);
       handleClose();
   }

   const approveRefunds = async (refundIds) => {
       const response = await ttAPI.approveRefunds(refundIds);
       handleClose();
   }

   const deleteRefunds = async (refundIds) => {
       const response = await ttAPI.deleteRefunds(refundIds);
       handleClose();
   }

   const openReceipt = async () => {
       window.open(
           `${config.googleStorageUrl}${data[selectedRowIndex].token}_rfnd.png`,
           '_blank'
       );
       handleClose();
   }

   function getRefundIds(selectedRows) {
      var refundIds = '';
      selectedRows.data.forEach(function (d) {
          refundIds += data[d.dataIndex].id + ',';
      });
      if (refundIds !== null && refundIds !== undefined && refundIds !== '') {
          refundIds = refundIds.slice(0, -1);
      }
      return refundIds;
  }

  function setupFromAndToFromFilter(filters) {
    var fromDate;
    var toDate;
    if (filters !== undefined && filters !== null) {
      if (filters[0] !== undefined && filters[1] !== undefined && filters[0] !== null && filters[1] !== null) {
        fromDate = new Date(filters[0]);
        toDate = new Date(filters[1]);
      }
      else {
        let timerange = getTwoWeekTimerange();
        fromDate = timerange.start;
        toDate = timerange.end;
      }
      setSelectedFrom(fromDate);
      setSelectedTo(toDate);
    }
  }

  useEffect(() => {
      if (refundConfirmationIsOpen && refundAction !== '') {
          if (refundAction === 'APPROVE') {
              if (selectedRowIndex >= 0) {
                  triggerRefundApproveConfirmation();
              }
              else {
                  triggerRefundApproveAllConfirmation();
              }
          }
          else if (refundAction === 'DELETE') {
              if (selectedRowIndex >= 0) {
                  triggerRefundDeleteConfirmation();
              }
              else {
                  triggerRefundDeleteAllConfirmation();
              }
          }
          setRefundConfirmationIsOpen(false);
      }
  },[selectedRowIndex, refundAction, refundConfirmationIsOpen]);

  const openRefundConfirmation = () => {
      setRefundConfirmationIsOpen(true);
  };

  function triggerRefundDeleteAllConfirmation() {
      let refundIds = data.map(item => item.id).join(',');
      refundConfirmationRef.current.openDeleteAllConfirmationPopup(refundIds);
  }

  function triggerRefundApproveAllConfirmation() {
      let refundIds = data.map(item => item.id).join(',');
      refundConfirmationRef.current.openApproveAllConfirmationPopup(refundIds);
  }

  function triggerRefundDeleteConfirmation() {
      refundConfirmationRef.current.openDeleteConfirmationPopup(data[selectedRowIndex].id);
  }

  function triggerRefundApproveConfirmation() {
      let refundIds = data.map(item => item.id).join(',');
      refundConfirmationRef.current.openApproveConfirmationPopup(data[selectedRowIndex].id);
  }

  const onConfirmRefundSuccess = async () => {
      handleClose();
      await refreshData();
  }

  const onEditableCellClick = (dataIndex, colIndex, isSelected) => {
     setSelectedRowIndex((!isSelected && selectedRowIndex == dataIndex) ? -1 : dataIndex);
  }

  async function handleSubmit (refundToUpdate) {

       const response = await ttAPI.updateRefund(refundToUpdate);

       if (response !== undefined && response.data !== undefined &&
           response.data) {
             if (response.data.success) {
               sendNotification('success', `Success - Retest ${refundToUpdate.id} Updated Successfully.`, classes);
             }
             else {
               sendNotification('error', `Failed to update Refund ${refundToUpdate.id}`, classes);
             }
       }
   }


   return (
     <>
     <PageTitle title="Refunds"/>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <div className={classes.refundsTopRow}>
              <div className="refunds_filter">
                <div className={classes.refundsCalendars}>
                    <TextField
                      id="from"
                      ref={fromRef}
                      label="From"
                      className={classnames({
                      'textField': true,
                      'refundsCalendarField': true,
                      [classes.calendarFocused]: fromFocused
                    })}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                              <CalendarTodayIcon />
                            </InputAdornment>
                          ),
                          inputComponent: () =>
                          <DatePicker
                          ref={fromCalendarRef}
                          className={classes.textField}
                          selected={selectedFrom}
                          onChange={handleChangeFrom}
                          onFocus={onFocusFrom}
                          onSelect={handleSelectFrom}
                          onClickOutside={blurFrom}
                          onKeyDown={handleFromKeyPress}
                          locale="en-NZ"
                          showTimeSelect
                          timeIntervals={30}
                          dateFormat="dd/MM/yyyy hh:mm aa"
                          />
                        }}
                    />
                    <TextField
                      id="to"
                      ref={toRef}
                      label="To"
                      className={classnames({
                      'textField': true,
                      'refundsCalendarField': true,
                      [classes.calendarFocused]: toFocused
                    })}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                              <CalendarTodayIcon />
                            </InputAdornment>
                          ),
                          inputComponent: () =>
                          <DatePicker
                          ref={toCalendarRef}
                          className={classes.textField}
                          selected={selectedTo}
                          onChange={handleChangeTo}
                          onFocus={onFocusTo}
                          onSelect={handleSelectTo}
                          onClickOutside={blurTo}
                          onKeyDown={handleToKeyPress}
                          locale="en-NZ"
                          showTimeSelect
                          timeIntervals={30}
                          dateFormat="dd/MM/yyyy hh:mm aa"
                          />
                        }}
                    />

                </div>
              </div>
              {data !== undefined && data !== null && data.length > 0 &&
                <div className={classes.refundsTableButtons}>
                  <Button className={classes.error} onClick={() => {
                    setRefundAction('DELETE');
                    openRefundConfirmation();
                  }}>DELETE ALL</Button>
                  {data.some(item =>
                    item.approved_by === null ||
                    item.approved_by === undefined ||
                    item.approved_by === "") &&
                  <Button onClick={() => {
                    setRefundAction('APPROVE');
                    openRefundConfirmation();
                  }}>APPROVE ALL</Button>}

              </div>}
            </div>

         <MuiThemeProvider theme={getMuiTheme()}>
           <MUIDataTable
             data={data !== undefined && data !== null ? data.map(item => {
                    return [item.id, //0
                     item.account_id, //1
                     item.name, //2
                     item.type, //3
                     item.job_id, //4
                     item.reason, //5
                     item.category, //6
                     item.amount, //7
                     item.token, //8
                     item.submitted, //9
                     item.approved_by, //10
                     item.late_submit ? 'YES' : 'NO'//11
                    ]
             }) : []}
             columns={columns}
             options={{
               fixedHeader: true,
               tableBodyHeight: '70vh',
               print: false,
               //serverSide: true,
               //search: false,
               search: true,
               //filter: false,
               viewColumns: false,
               print: false,
               //download: false,
               download: true,
               selectableRows: 'single',
               selectableRowsHideCheckboxes: true,
               selectableRowsHeader: false,
               rowsPerPageOptions: [10,15,20,50,100,200],
               rowsPerPage: 200,
               selectableRowsOnClick: false,
               textLabels: {
                  body: { noMatch : isLoading ? <CircularProgress size={25} color={'inherit'} /> : 'Sorry, no matching records found.' },
                  selectedRows: {
                    text: "Refund(s) selected",
                  }
               },
               downloadOptions: {filterOptions:{useDisplayedColumnsOnly: false, useDisplayedRowsOnly: false}},
               onDownload: (buildHead, buildBody, columns, data) => {
                   var from = selectedFrom;
                   var to = selectedTo;

                   if (from === undefined || from === null || to === undefined || to === null) {
                       let timerange = getTwoWeekTimerange();
                       from = timerange.start;
                       to = timerange.end;
                   }

                   let [f_date, f_month, f_year] = from.toLocaleDateString('en-NZ').split("/");
                   let f_hour = ('0' + from.getHours()).slice(-2);
                   let f_minute = ('0' + from.getMinutes()).slice(-2);
                   let f_time = `${f_hour}:${f_minute}`;
                   let [t_date, t_month, t_year] = to.toLocaleDateString('en-NZ').split("/");
                   let t_hour = ('0' + to.getHours()).slice(-2);
                   let t_minute = ('0' + to.getMinutes()).slice(-2);
                   let t_time = `${t_hour}:${t_minute}`;
                  window.open(
                      `${config.clientApi}/reports/refund?&start=${f_year}-${f_month}-${f_date}%20${encodeURIComponent(f_time)}&end=${t_year}-${t_month}-${t_date}%20${encodeURIComponent(t_time)}`,
                      '_blank'
                      );
                     return false;
               },
               /*onTableChange: (action, tableState) => {
                  if (action === 'selectRow' && tableState.selectedRows) {
                    setSelectedRefundRows(tableState.selectedRows.map((row) => row.dataIndex));
                  }
              },*/
               onTableInit: (action, tableState) => {
                   if (localStorage.getItem('refunds_filter_list') === undefined || localStorage.getItem('refunds_filter_list') === null) {
                       localStorage.setItem('refunds_filter_list', JSON.stringify(Array(2).fill([])));

                       let timerange = getTwoWeekTimerange();
                       setSelectedFrom(timerange.start);
                       setSelectedTo(timerange.end);

                       let datetimeRange = processDateRange(timerange.start, timerange.end);
                       var filterList = JSON.parse(localStorage.getItem('refunds_filter_list'));
                       filterList[0] = datetimeRange.from;
                       filterList[1] = datetimeRange.to;
                       localStorage.setItem('refunds_filter_list', JSON.stringify(filterList));
                   }
                   else if (JSON.parse(localStorage.getItem('refunds_filter_list'))[0] !== undefined && JSON.parse(localStorage.getItem('refunds_filter_list'))[0] !== null &&
                            JSON.parse(localStorage.getItem('refunds_filter_list'))[1] !== undefined && JSON.parse(localStorage.getItem('refunds_filter_list'))[1] !== null) {
                        var filterList = JSON.parse(localStorage.getItem('refunds_filter_list'));
                        setupFromAndToFromFilter(filterList);
                   }
               },
               /*customToolbar: () => <CustomHeaderCheckbox onCheckboxChange={handleHeaderCheckboxChange} />,
               customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
                  return (
                      <div>
                          <Tooltip title="Approve">
                              <IconButton onClick={() => {
                                let refundIds = getRefundIds(selectedRows);
                                approveRefunds(refundIds);
                              }}>
                                  <CheckIcon />
                              </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete">
                              <IconButton onClick={() => {
                                let refundIds = getRefundIds(selectedRows);
                                deleteRefunds(refundIds);
                              }}>
                                  <DeleteIcon />
                              </IconButton>
                          </Tooltip>
                      </div>

                  );
              },*/
               customRowRender: (rowData, dataIndex, rowIndex) => {
                  //const isChecked = selectedRefundRows.includes(rowIndex);
                      return  (
                         <TableRow key={rowData[0]} id={dataIndex}
                                   className={classnames({
                                   //[classes.lateSubmit]: rowData[11] === 'YES',
                                   [classes.approved]: rowData[10] !== undefined && rowData[10] !== null && rowData[10] !== ''
                                 })}>
                             <TableCell>
                                  <div></div>
                             </TableCell>
                             <TableCell>
                                  <div>{rowData[0]}</div>
                             </TableCell>
                             {/*<TableCell>
                                     <Checkbox
                                     onChange={() => {
                                          const newSelectedRefundRows = isChecked
                                            ? selectedRefundRows.filter((row) => row !== rowIndex)
                                            : [...selectedRefundRows, rowIndex];
                                          setSelectedRefundRows(newSelectedRefundRows);
                                        }}
                                       name="refund_check_box"
                                       color="primary"
                                     />


                             </TableCell>*/}
                             <TableCell>
                                  <div className={classes.imageNameColumn}>
                                      <div className={classes.accountImageDiv}>
                                         <img className={classes.accountImage} alt={`${rowData[1]} - ${rowData[2]}`}
                                              src={`${config.hostApi}${config.portApi ? `:${config.portApi}` : ``}/client/aimages/${rowData[1]}?${getRandomInt(1000000)}`}/>
                                      </div>
                                  <div style={{ paddingLeft: '10px' }}>{rowData[2]}</div>
                                  </div>
                             </TableCell>
                             <TableCell className={classnames({
                                 [classes.selectedBorder]: isEditingType && dataIndex === selectedRowIndex/*rowIndex === selectedRowIndex*/,
                                 [classes.noPadding]: isEditingType && dataIndex === selectedRowIndex/*rowIndex === selectedRowIndex*/,
                               })}
                              onClick={(event) => {
                                    setIsEditingJobId(false);
                                    setIsEditingType(true);
                                    setIsEditingAmount(false);
                                    setIsEditingCategory(false);
                                    onCellClick(dataIndex, 3);
                                    onEditableCellClick(dataIndex, 3, true);
                                  }}>
                             {isEditingType && dataIndex === selectedRowIndex/*rowIndex === selectedRowIndex*/ ?
                               <FormControl variant="outlined" className={classnames({
                                     'refundTypeCategorySelect':  true,
                                     'refund-select-control': true
                                   })}
                                   tabIndex={0}
                                   onBlur={event => {console.log('onblur formcontrol of status'); }

                                 }>
                                 <div className={classnames({
                                               'select-control-input': true
                                             })}>
                                   <Select
                                     style={{width: '100%'}}
                                     value={data[dataIndex].type || ''}
                                     onChange={event => {
                                         setIsEditingType(false);
                                         data[dataIndex].type = event.target.value;
                                         setData(data);
                                         let dataToSubmit = data[dataIndex];
                                         const matchingRefundType = refund_types.find(refund => refund.type_name === event.target.value);

                                          if (matchingRefundType) {
                                            dataToSubmit.type_id = matchingRefundType.id
                                            handleSubmit(dataToSubmit);
                                          } else {
                                            console.log('No matching type_name found');
                                          }
                                     }}
                                     onBlur={event => {  setIsEditingType(false);
                                     }}
                                     open={refundTypesOpen}
                                     onClose={() => {setRefundTypesOpen(false);}}
                                     onOpen={() => {setRefundTypesOpen(true);}}
                                   >
                                   {refund_types !== undefined && refund_types !== null &&
                                     refund_types.length > 0 &&
                                     refund_types.map((refundType, index) => (
                                          <MenuItem key={refundType.id} value={refundType.type_name}
                                             onClick={() => {setRefundTypesOpen(false);}}>
                                             <span className="dropdown-avatar">{refundType.type_name}</span>
                                          </MenuItem>
                                   ))}


                                   </Select>
                                 </div>
                               </FormControl>

                               : <div>{rowData[3]}</div>}
                             </TableCell>
                             <TableCell className={classnames({
                                                   [classes.selectedBorder]: isEditingJobId && dataIndex === selectedRowIndex/*rowIndex === selectedRowIndex*/,
                                                   [classes.noPadding]: isEditingJobId && dataIndex === selectedRowIndex/*rowIndex === selectedRowIndex*/,
                                                 })}
                                        onClick={(event) => {
                                             setIsEditingJobId(true);
                                             setIsEditingType(false);
                                             setIsEditingAmount(false);
                                             setIsEditingCategory(false);
                                             onCellClick(dataIndex, 4);
                                             onEditableCellClick(dataIndex, 4, true);
                                            }}
                                        style={{minWidth: '200px', maxWidth: '300px'}}>
                                        {isEditingJobId && dataIndex === selectedRowIndex/*rowIndex === selectedRowIndex*/ ?
                                          <TextField
                                            id={`job_id_${dataIndex}`}
                                            name="job id"
                                            variant="standard"
                                            type={'number'}
                                            style={{minWidth: '250px'}}
                                            defaultValue={rowData[4] || ''}
                                            onBlur={event => {
                                              setIsEditingJobId(false);
                                              if (event.target.value !== null && event.target.value !== undefined && event.target.value !== '') {
                                                  data[dataIndex].job_id = Number(event.target.value);
                                              }
                                              else if (event.target.value === '') {
                                                  data[dataIndex].job_id = null;
                                              }
                                              setData(data);
                                              let dataToSubmit = data[dataIndex];
                                              handleSubmit(dataToSubmit);
                                            }}

                                            autoFocus
                                            InputProps={{
                                              disableUnderline: true,
                                            }}
                                          />

                                          :
                                          (rowData[4] === undefined || rowData[4] === null || rowData[4] === '' ?
                                            <div style={{lineHeight: 1.2,
                                                         display: '-webkit-box',
                                                         WebkitLineClamp: 3,
                                                         WebkitBoxOrient: 'vertical',
                                                         overflow: 'hidden',
                                                         textOverflow: 'ellipsis'}}>
                                                         {rowData[4]}
                                                         </div>
                                           :
                                           <Tooltip title={rowData[4]}>
                                             <div style={{lineHeight: 1.2,
                                                          display: '-webkit-box',
                                                          WebkitLineClamp: 3,
                                                          WebkitBoxOrient: 'vertical',
                                                          overflow: 'hidden',
                                                          textOverflow: 'ellipsis'}}>
                                                          {rowData[4]}
                                                          </div>
                                            </Tooltip>
                                          )}
                                        </TableCell>
                             <TableCell>
                                  <div>{rowData[5]}</div>
                             </TableCell>
                             <TableCell className={classnames({
                                 [classes.selectedBorder]: isEditingCategory && dataIndex === selectedRowIndex/*rowIndex === selectedRowIndex*/,
                                 [classes.noPadding]: isEditingCategory && dataIndex === selectedRowIndex/*rowIndex === selectedRowIndex*/,
                               })}
                              onClick={(event) => {
                                    setIsEditingJobId(false);
                                    setIsEditingType(false);
                                    setIsEditingAmount(false);
                                    setIsEditingCategory(true);
                                    onCellClick(dataIndex, 6);
                                    onEditableCellClick(dataIndex, 6, true);
                                  }}>
                             {isEditingCategory && dataIndex === selectedRowIndex/*rowIndex === selectedRowIndex*/ ?
                               <FormControl variant="outlined" className={classnames({
                                     'refundTypeCategorySelect':  true,
                                     'refund-select-control': true
                                   })}
                                   tabIndex={0}
                                   onBlur={event => {console.log('onblur formcontrol of status'); }

                                 }>
                                 <div className={classnames({
                                               'select-control-input': true
                                             })}>
                                   <Select
                                     style={{width: '100%'}}
                                     value={data[dataIndex].category || ''}
                                     onChange={event => {
                                         setIsEditingCategory(false);
                                         data[dataIndex].category = event.target.value;
                                         setData(data);
                                         let dataToSubmit = data[dataIndex];
                                         const matchingRefundCategory= refund_categories.find(refund => refund.category_name === event.target.value);

                                          if (matchingRefundCategory) {
                                            dataToSubmit.category_id = matchingRefundCategory.id
                                            handleSubmit(dataToSubmit);
                                          } else {
                                            console.log('No matching category_name found');
                                          }
                                     }}
                                     onBlur={event => {  setIsEditingCategory(false);
                                     }}
                                     open={refundCategoriesOpen}
                                     onClose={() => {setRefundCategoriesOpen(false);}}
                                     onOpen={() => {setRefundCategoriesOpen(true);}}
                                   >
                                   {refund_categories !== undefined && refund_categories !== null &&
                                     refund_categories.length > 0 &&
                                     refund_categories.map((refundCategory, index) => (
                                          <MenuItem key={refundCategory.id} value={refundCategory.category_name}
                                             onClick={() => {setRefundCategoriesOpen(false);}}>
                                             <span className="dropdown-avatar">{refundCategory.category_name}</span>
                                          </MenuItem>
                                   ))}


                                   </Select>
                                 </div>
                               </FormControl>

                               : <div>{rowData[6]}</div>}
                             </TableCell>
                             <TableCell className={classnames({
                                                   [classes.selectedBorder]: isEditingAmount && dataIndex === selectedRowIndex/*rowIndex === selectedRowIndex*/,
                                                   [classes.noPadding]: isEditingAmount && dataIndex === selectedRowIndex/*rowIndex === selectedRowIndex*/,
                                                 })}
                                        onClick={(event) => {
                                             setIsEditingJobId(false);
                                             setIsEditingType(false);
                                             setIsEditingAmount(true);
                                             setIsEditingCategory(false);
                                             onCellClick(dataIndex, 7);
                                             onEditableCellClick(dataIndex, 7, true);
                                            }}
                                        style={{minWidth: '200px', maxWidth: '300px'}}>
                                        {isEditingAmount && dataIndex === selectedRowIndex/*rowIndex === selectedRowIndex*/ ?
                                          <TextField
                                            id={`amount_${dataIndex}`}
                                            name="amount"
                                            variant="standard"
                                            type={'number'}
                                            style={{minWidth: '250px'}}
                                            defaultValue={rowData[7] || ''}
                                            onBlur={event => {
                                              setIsEditingAmount(false);
                                              if (event.target.value !== null && event.target.value !== undefined && event.target.value !== '') {
                                                  data[dataIndex].amount = Number(event.target.value);
                                              }

                                              setData(data);
                                              let dataToSubmit = data[dataIndex];
                                              handleSubmit(dataToSubmit);
                                            }}

                                            autoFocus
                                            InputProps={{
                                              disableUnderline: true,
                                              startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                            }}
                                          />

                                          :
                                          (rowData[7] === undefined || rowData[7] === null || rowData[7] === '' ?
                                            <div style={{lineHeight: 1.2,
                                                         display: '-webkit-box',
                                                         WebkitLineClamp: 3,
                                                         WebkitBoxOrient: 'vertical',
                                                         overflow: 'hidden',
                                                         textOverflow: 'ellipsis'}}>
                                                         {rowData[7]}
                                                         </div>
                                           :
                                           <Tooltip title={rowData[7]}>
                                             <div style={{lineHeight: 1.2,
                                                          display: '-webkit-box',
                                                          WebkitLineClamp: 3,
                                                          WebkitBoxOrient: 'vertical',
                                                          overflow: 'hidden',
                                                          textOverflow: 'ellipsis'}}>
                                                          ${rowData[7]}
                                                          </div>
                                            </Tooltip>
                                          )}
                                        </TableCell>
                             <TableCell className={classnames({
                             [classes.lateSubmitText]: rowData[11] === 'YES'})}>
                                  <div>{rowData[9].replace('T', ' ')}</div>
                             </TableCell>
                             <TableCell onClick={() => onCellClick(dataIndex, 10)}>
                                 <div>
                                     {(rowData[10] === null ||
                                      rowData[10] === undefined ||
                                      rowData[10] === '' || rowData[10] <= 0) &&
                                      <><Button className={classes.approveButton} onClick={() => {
                                        setRefundAction('APPROVE');
                                        openRefundConfirmation();
                                      }}>ARRPOVE</Button>&nbsp;</>}
                                     <IconButton color="primary"
                                           component="span"
                                           onClick={handleClick}>
                                         <MoreVertIcon />
                                     </IconButton>
                                 </div>
                             </TableCell>
                         </TableRow>
                       );
               },
               setRowProps: (row, dataIndex, rowIndex) => {
                   return {
                     className: classnames({
                         [classes.selectedBorder]: (isEditingJobId || isEditingAmount) && dataIndex === selectedRowIndex /*rowIndex === selectedRowIndex*/
                       }),
                   };

               },
             }}
           />
         </MuiThemeProvider>
         </Grid>
         </Grid>
         {
           <StyledMenu
               id="customized-menu"
               anchorEl={anchorEl}
               keepMounted
               open={Boolean(anchorEl)}
               onClose={handleClose}

             >
               <StyledMenuItem onClick={() => {
                 setRefundAction('DELETE');
                 openRefundConfirmation();
               }}>
                 <ListItemIcon>
                   <DeleteIcon fontSize="small" />
                 </ListItemIcon>
                 <ListItemText primary="Delete" />
               </StyledMenuItem>
               <StyledMenuItem onClick={openReceipt}>
                 <ListItemIcon>
                   <ReceiptIcon fontSize="small" />
                 </ListItemIcon>
                 <ListItemText primary="View Receipt" />
               </StyledMenuItem>
             </StyledMenu>

         }
         <RefundConfirmation ref={refundConfirmationRef}
                            closeMenu={handleClose}
                            onConfirmationSuccess={onConfirmRefundSuccess}/>
     </>
   );
});

export default Refunds;
